import { ISbResult } from 'storyblok-js-client'
import { Ref } from 'vue'
import { StoryblokDataSource } from '~~/types/storyblok/defaults'
import { useAsyncStoryblokQuery } from './useAsyncStoryblokQuery'

export interface StoryblokDatasourceResult extends ISbResult {
  data: {
    datasource_entries: StoryblokDataSource[]
  }
}

export const useAsyncStoryblokDatasourceQuery = async (params = {}) => {
  const key = 'datasource_entries'
  const slug = 'cdn/datasource_entries/'

  return (await useAsyncStoryblokQuery(
    key,
    slug,
    params
  )) as Ref<StoryblokDatasourceResult>
}
